import { FC } from "react";
import { Button } from "@mui/material";
import { StyledLoadingButton } from "../atoms";
import { GenericDialog, GenericDialogProps } from "./GenericDialog";

export interface ConfirmDialogProps extends GenericDialogProps {
  onConfirmed: () => void | Promise<void>;
  isLoading?: boolean;
}

const ConfirmActions: FC<ConfirmDialogProps> = ({
  onClose,
  onConfirmed,
  isLoading,
}) => {
  const onConfirmClicked = () => {
    onConfirmed();
    onClose();
  };

  return (
    <>
      <Button
        color="secondary"
        variant="text"
        onClick={onClose}
        disabled={isLoading}
      >
        No
      </Button>
      <StyledLoadingButton
        color="primary"
        variant="contained"
        onClick={onConfirmClicked}
        loading={isLoading}
      >
        Yes
      </StyledLoadingButton>
    </>
  );
};

const ConfirmDialog: FC<ConfirmDialogProps> = (props) => {
  const { actions } = props;
  return (
    <GenericDialog
      {...props}
      actions={actions ?? <ConfirmActions {...props} />}
    />
  );
};

export { ConfirmDialog };
